import { motion } from "framer-motion";
import { Check } from "lucide-react";

export default function Audience({ data }) {
  return (
    <section id="audience" data-testid="audience-section" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-5 lg:sticky lg:top-24 lg:self-start"
        >
          <p className="overline mb-6" data-testid="audience-overline">{data.overline}</p>
          <h2
            data-testid="audience-title"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light leading-tight text-onyx"
          >
            {data.title}
          </h2>
          <p data-testid="audience-subtitle" className="mt-6 text-onyx/70 text-lg">
            {data.subtitle}
          </p>
        </motion.div>

        <div className="lg:col-span-7">
          <ul className="space-y-5">
            {(data.items || []).map((item, i) => (
              <motion.li
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                data-testid={`audience-item-${i}`}
                className="flex items-start gap-5 pb-5 border-b border-border"
              >
                <span className="flex-shrink-0 w-10 h-10 rounded-full bg-onyx flex items-center justify-center">
                  <Check size={16} className="text-gold" strokeWidth={2.5} />
                </span>
                <p className="text-lg sm:text-xl text-onyx leading-relaxed pt-1.5">
                  {item.text}
                </p>
              </motion.li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
